/*****************************************************************************************
 * 설명 : 관리자 > 시스템관리 > 권한그룹 관리 > 복사
 * URI : /admin/system/auth/group
*****************************************************************************************/
import React, { useEffect } from 'react';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import { useFormik } from 'formik';
import * as Yup from "yup";

import Restful from 'service/restful';
import { setAuthGroupCopyApi } from 'service/auth';

import { InputEx, ToggleButtonGroupEx } from 'components/inputEx';
import alertMsg from 'components/message';
import { MESSAGE_DELAY } from 'config/config';

/*****************************************************************************************
 * 설명 : 함수 선언
*****************************************************************************************/
export const AuthGroupCopyModal = ( props ) => {

  /***************************************************************************************
   * 설명 : 변수 선언부
  ***************************************************************************************/
  const [getApi] = Restful();

  const formik = useFormik({
    initialValues: {
      seq: 0,
      copySeq: 0,
      authGroupName: '',
      authGroupNameCopy: '',
      isAdmin: 0,
      isUse: 1
    },
    validationSchema: Yup.object().shape({
      authGroupName: Yup.string().max(45, "45자리").required('필수')
    }),
    onSubmit: (values) => {
      // 추가시 중북된 권한명 체크
      let tmp = props.list.filter((item) => item.authGroupName === values.authGroupNameCopy);
      if( tmp.length > 0 ) {
        alertMsg("중복되는 권한그룹명이 존재합니다. 다른 권한그룹명을 입력하시기 바랍니다.", "W", MESSAGE_DELAY);
        return;
      }

      setAuthGroupCopyApi(getApi, values, (response => {
        if( response !== undefined && response.data.result ) {
          alertMsg(response.data.message, "S", MESSAGE_DELAY);

          if( props.getList ) props.getList();

          if( props.setSelected ) props.setSelected([{seq: response.data.data.seq}])

          props.close();

        } else {
          alertMsg(response.data.message || '서버와의 통신에 실패하였습니다.', "E", MESSAGE_DELAY);
        }
      }));
    }
  });

  /***************************************************************************************
   * 설명 : 모달 오픈 시 처리
  ***************************************************************************************/
  useEffect(() => {
    if( props.open ) {
      if( props.data.seq !== undefined ) {
        formik.setValues(props.data);
        formik.setFieldValue('copySeq', props.data?.seq);
      }
    }

    // eslint-disable-next-line
  }, [props.open]);

  /***************************************************************************************
   * 설명 : html 선언부
  ***************************************************************************************/
  return (
    <section className="modal-wrap" style={{ width: '500px' }}>
      <form onSubmit={formik.handleSubmit}>
        <header className="modal-header" style={{ cursor: 'move' }} id="draggable-dialog-title">
          <div className="modal-title">권한그룹 복사</div>
          <Button className="close-btn" onClick={props.close}>
            <CloseIcon style={{ color: '#fff', fontSize: '28px' }}></CloseIcon>
          </Button>
        </header>

        <section className="modal-body">
          <table className="input-table">
            <colgroup>
              <col style={{width: '25%'}} />
              <col style={{width: '75%'}} />
            </colgroup>

            <tbody>
              <tr>
                <th scope="row"><label htmlFor="authGroupName">권한그룹명</label></th>
                <td>
                  <InputEx
                    name="authGroupName"
                    formik={formik}
                    fullWidth={true}
                    disabled={true}
                  />
                </td>
              </tr>
              <tr>
                <th scope="row"><label htmlFor="authGroupNameCopy">복사 권한그룹명</label></th>
                <td>
                  <InputEx
                    name="authGroupNameCopy"
                    formik={formik}
                    fullWidth={true}
                    focus={true}
                    label={"복사 권한그룹명 입력"}
                    inputProps={{autoFocus: true}}
                  />
                </td>
              </tr>
              <tr>
                <th scope="row"><label htmlFor="isAdmin">관리자여부</label></th>
                <td>
                  <ToggleButtonGroupEx
                    name="isAdmin"
                    exclusive={true}
                    formik={formik}
                    data={[
                      {label: '일반사용자', value: 0},
                      {label: '관리자', value: 1},
                    ]}
                  />
                </td>
              </tr>
              <tr>
                <th scope="row"><label htmlFor="isUse">사용여부</label></th>
                <td>
                  <ToggleButtonGroupEx
                    name="isUse"
                    exclusive={true}
                    formik={formik}
                    data={[
                      {label: '사용', value: 1},
                      {label: '사용안함', value: 0},
                    ]}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </section>

        <footer className="modal-footer">
          <div className="modal-footer-center">
            <Button
              color="inherit"
              variant="outlined"
              className="Btn"
              onClick={() => {
                props.close();
              }}
            >창닫기</Button>

            <Button
              type="submit"
              variant="contained"
              color="primary"
              className="Btn ml10"
            >저장하기</Button>
          </div>
        </footer>
      </form>
    </section>
  )
}

export default AuthGroupCopyModal;